import { Pipe, PipeTransform } from "@angular/core";
import { UserCompanyRole } from "../models/user-company.model";

@Pipe({
    name: "roleLabel",
    standalone: false
})
export class RoleLabelPipe implements PipeTransform {
  transform(role: UserCompanyRole | string): string {
    switch (role) {
      case UserCompanyRole.BREEDER_ADMIN:
      case "breederadmin":
        return "Utilisateur Admin";
      case UserCompanyRole.BREEDER:
      case "breeder":
        return "Utilisateur";
      case UserCompanyRole.COOP_TECH:
      case "cooptech":
        return "Technicien coop";
      default:
        return role;
    }
  }
}
